// extracted by mini-css-extract-plugin
export default {"colors":"accent,neutral,negative,warning,positive","text":"styles_text__+d46B","clampedText":"styles_clampedText__6MNXe"};